var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.13469 1.44609C3.13469 2.24995 2.5296 2.89318 1.55802 2.89318H1.54022C0.604757 2.89318 0 2.24995 0 1.44609C0 0.625222 0.623176 0 1.57639 0C2.5296 0 3.1166 0.625222 3.13469 1.44609ZM2.95113 4.03592V12.4079H0.164724V4.03592H2.95113ZM12.9998 12.4079L12.9999 7.60764C12.9999 5.03613 11.6253 3.8393 9.79175 3.8393C8.31235 3.8393 7.65 4.65189 7.28018 5.22194V4.03612H4.49345C4.53017 4.8217 4.49345 12.4081 4.49345 12.4081H7.28018V7.73249C7.28018 7.48228 7.29827 7.23268 7.37194 7.05354C7.57332 6.55367 8.03184 6.03614 8.80165 6.03614C9.81034 6.03614 10.2135 6.80383 10.2135 7.92886V12.4079H12.9998Z",
    fill: "#888888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedinIcon.ebf9d84ce328f3c39c7f020f982ca7cb.svg";
export { ForwardRef as ReactComponent };